import React from 'react'
import LottieAnimation from './LottieAnimation.web'
import ButtonAnimation from 'app/animations/buttonLoader.json'
import { Platform } from 'react-native'

const ButtonLoader = () => (
  <>
    {Platform.OS == 'web' ? (
      <LottieAnimation animationData={ButtonAnimation} />
    ) : null}
  </>
)

export default ButtonLoader
